import * as React from 'react';
import loadable from '@loadable/component';
import { ROUTES } from './_constant';
import { useRoutes, useNavigate } from 'react-router-dom';
import { Loading, ScrolltoTop, AlertSnackbar, AlertDialog } from './_component';
import { Box } from '@mui/material';
import { checkIP } from './_fn';
import { NotCompany } from './page/NotCompany';
import { useLocation } from 'react-router-dom';


const Header = loadable(() => import('./header/Header'), { fallback: <Loading /> });
const Footer = loadable(() => import('./footer/Footer'), { fallback: <Loading /> });


/** 主框架 */
export function Frame({ ColorModeContext }) {

  const routeResult = useRoutes(ROUTES);  // 路由

  /**
   * 檢視 IP
   * @param {boolean} inCompany 是否是公司 IP
   * @param {boolean} master 是否是正式站
   */
  const [inCompany, setInCompany] = React.useState(null);
  const check_ip_callback = ({ inCompany, master }) => {
    // console.log('檢是否是公司 IP', inCompany);
    if (inCompany || master) {
      setInCompany(true);
    } else {
      setInCompany(false);
    }
  }

  React.useEffect(() => {

    if (global.domain.type === 'master') {
      setInCompany(true);
    } else {
      checkIP({ callback: check_ip_callback }); // 非正式站需檢查 IP
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate()
  const location = useLocation()

  React.useEffect(() => {

    // 切換路由後卷軸拉上去
    window.scrollTo({ top: 0 })

    const pathname = location.pathname
    const homeRouter = '/custom-itinerary'
    const homeRouterB = '/custom-itinerary/'
    const contactRouter = '/custom-itinerary/contact' // contact有自己的玩法，元件內設定
    const viewOrderRegex = /^\/custom-itinerary\/viewOrder\/[^/]+$/
    const viewRegex = /^\/custom-itinerary\/view\/[^/]+$/
    const orderRouter = '/custom-itinerary/order'
    const lastStep = sessionStorage.getItem('lastStep')

    // 非法操作:從訂單頁面跳回非首頁的區塊 (要先在放行前先擋下)
    const isFromViewOrder =
      viewOrderRegex.test(lastStep || '') ||
      viewRegex.test(lastStep || '') ||
      lastStep === orderRouter
    const isInOrderFlow =
      viewOrderRegex.test(pathname) ||
      viewRegex.test(pathname) ||
      pathname === orderRouter

    if (
      isFromViewOrder &&
      !isInOrderFlow &&
      pathname !== homeRouter &&
      pathname !== homeRouterB
    ) {
      sessionStorage.setItem('lastStep', homeRouter)
      return navigate(homeRouter)
    }

    // 特例放行
    if (viewOrderRegex.test(pathname) || viewRegex.test(pathname) || pathname === contactRouter || pathname === orderRouter) {
      return sessionStorage.setItem('lastStep', pathname)
    }

    const isFromHome = lastStep === homeRouter || lastStep === homeRouterB
    const aiRouters = [
      '/custom-itinerary/prefer',
      '/custom-itinerary/modifyTour',
      '/custom-itinerary/requirement'
    ]
    // 因為有參數，這邊要使用Regexp
    const aiSegments = [...aiRouters.map(path => path.split('/').pop()), 'contact']
    const recommendRegex = new RegExp(
      `^/custom-itinerary/(recommend|expense|(?!${aiSegments.join('|')})[^/]+)$`
    )

    // 重新整理放行
    if (pathname === lastStep) {
      return
    }

    // 非法操作:非首頁進入第一步驟 (首頁會reset資料，確保運作正常)
    const illegalDirectEnter =
      (!isFromHome && pathname === aiRouters[0]) ||
      (!isFromHome && pathname === '/custom-itinerary/recommend')

    // 非法操作:流程互跳
    const illegalDirectJump =
      (aiRouters.includes(pathname) && recommendRegex.test(lastStep || '')) ||
      (recommendRegex.test(pathname) && aiRouters.includes(lastStep || ''))

    if (illegalDirectEnter || illegalDirectJump) {
      sessionStorage.setItem('lastStep', homeRouter)
      return navigate(homeRouter)
    }

    sessionStorage.setItem('lastStep', pathname)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, navigate]);

  return (
    <>
      <ScrolltoTop />
      <AlertSnackbar />
      <AlertDialog />
      <Header ColorModeContext={ColorModeContext} />
      <Box component='main'>
        {inCompany === true && routeResult}
        {inCompany === false && <NotCompany />}
        {/* inCompany === null 時什麼都不顯示 */}
      </Box>
      <Footer />
    </>
  )
}